import { useAppSelector } from "redux/hooks";
import { getCourses } from "redux/slices/coursesSlice";
import { getFormations } from "redux/slices/formationsSlice";

type RowObj = {
  id: number;
  title: string;
  description: string;
  addedOn: Date;
  formation: string;
  lastModifiedOn: Date;
};

const useTableDataCheck = () => {
  const courses = useAppSelector(getCourses).courses.filter(
    (value, index, self) =>
      index ===
      self.findIndex(
        (item) =>
          item.title === value.title && item.description === value.description
      )
  );
  const formations = useAppSelector(getFormations).formations;
  return courses.map((course) => {
    return {
      id: course.id,
      title: course.title,
      description: course.description,
      addedOn: course.addedOn,
      lastModifiedOn: course.lastModifiedOn,
      formation: formations.find(
        (formation) => formation.id === course.formationId
      ).title,
    };
  });
};
export default useTableDataCheck;
